import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  GeneralStyle,
  FormCard,
  SectionWrapper,
} from "./SitesCreationForm.styled";
import { Row, Col } from "react-bootstrap";
import { theme as themeConfig } from "../../themes/themes";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  ALL_CITIES_BY_COUNTRY_ID_LIST,
  ALL_COUNTRY_LIST,
} from "../../GraphQL/Queries";
import { UPDATE_SITE, CREATE_LOCATION } from "../../GraphQL/Mutations";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import { NotificationManager } from "react-notifications";

const SitesCreationForm = ({
  user,
  setFormTrigger,
  editRowData,
  setReloadRender,
}) => {
  const [cities, setCities] = useState([]);
  const rSelectedCountry = useRef();
  const rSelectedCity = useRef();
  const [createLocation, { loading: loadingCreateLocation }] =
    useMutation(CREATE_LOCATION);
  const [updateSite, { loading: loadingUpdateSite }] = useMutation(UPDATE_SITE);

  const {
    data: countries,
    loading: loadingCountries,
    error: errorCountries,
  } = useQuery(ALL_COUNTRY_LIST, {
    variables: { clientId: user.clientId },
    context: { clientName: "LinkUsers" },
  });

  const [
    runQueryCitiesByCountryId,
    { loading: loadingCities, error: errorCities },
  ] = useLazyQuery(ALL_CITIES_BY_COUNTRY_ID_LIST, {
    fetchPolicy: "network-only",
    context: { clientName: "LinkUsers" },
    onCompleted: (data) => {
      let resultOfCities = data.allCitiesByCountryId.map((element) => ({
        ...element,
      }));
      setCities(resultOfCities);
    },
  });

  let handleSaveSite = () => {
    setReloadRender(true);
    let cityId;
    if (rSelectedCity.current.value) {
      cityId = JSON.parse(rSelectedCity.current.value).cityId;
    }
    if (cityId) {
      createLocation({
        variables: {
          cityId: cityId,
        },
        context: { clientName: "LinkUsers" },
      })
        .then((response) => {
          if (response?.data?.createLocation?.cityId) {
            NotificationManager.success(
              "Your Site was successfully created",
              "",
              5000
            );
            setFormTrigger("");
            setReloadRender(false);
          } else {
            NotificationManager.error("Error", "", 5000);
            setFormTrigger("");
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning(
        "Please type all the fields to create your Site",
        "",
        5000
      );
    }
  };

  let handleUpdateSite = () => {
    setReloadRender(true);
    let siteId = editRowData.siteId;
    let username = user.userName;
    let clientid = user.clientId;
    if (siteId && username && clientid) {
      updateSite({
        variables: {
          input: {
            siteId: siteId,
            lastUpdateUser: username,
            clientId: clientid,
          },
        },
        context: { clientName: "LinkUsers" },
      })
        .then((response) => {
          let err = response.data.updateSite.errors;
          let resp = response.data.updateSite.siteCreated;
          if (resp !== null && err === null) {
            NotificationManager.success(
              "Your Site was successfully updated",
              "",
              5000
            );
            setFormTrigger("");
            setReloadRender(false);
          }
          if (err !== null && resp === null) {
            NotificationManager.error(err.message, "", 5000);
            setFormTrigger("");
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning(
        "Please type all the fields to update your Site",
        "",
        5000
      );
    }
  };

  let loadCountries = () => {
    if (loadingCountries) return <option key="0">Loading...</option>;
    if (errorCountries) return <option key="0">Error :(</option>;
    if (countries && !loadingCountries && !errorCountries) {
      return countries?.allCountryList?.map((data) => {
        return (
          <option
            key={data.countryId}
            selected={
              String(data.countryName).toLowerCase() ===
                String(editRowData?.country).toLowerCase()
                ? true
                : false
            }
            value={JSON.stringify({ ...data })}
          >
            {data.countryName}
          </option>
        );
      });
    }
  };

  let loadCities = () => {
    if (loadingCities) return <option key="0">Loading...</option>;
    if (errorCities) return <option key="0">Error :(</option>;
    if (
      Array.isArray(cities) &&
      cities.length > 0 &&
      !loadingCities &&
      !errorCities
    ) {
      return cities.map((data) => {
        return (
          <option
            key={data.cityId}
            selected={
              String(data.cityName).toLowerCase() ===
                String(editRowData?.city).toLowerCase()
                ? true
                : false
            }
            value={JSON.stringify({ ...data })}
          >
            {data.cityName}
          </option>
        );
      });
    }
  };

  const getCities = (id) => {
    if (countries?.allCountryList && id) {
      runQueryCitiesByCountryId({
        variables: {
          countryId: id,
        },
      });
    }
  };

  let handleCountrySelected = (item) => {
    let countryId = JSON.parse(item).countryId;
    rSelectedCity.current.value = "";
    if (user && countryId) {
      getCities(countryId);
    }
  };

  useEffect(() => { }, [editRowData, countries]);

  return (
    <>
      <GeneralStyle>
        <FormCard>
          <SectionWrapper>
            <h1>{editRowData ? "Edit Location" : "Create Location"}</h1>
            <CloseIcon onClick={() => setFormTrigger("")} />
            <hr />
          </SectionWrapper>
          <SectionWrapper>
            {loadingCountries && <PointersLine color={themeConfig.text.primary} />}
            {!loadingCountries && (
              <Row>
                <Col md="12">
                  <label>Country</label>&nbsp;
                  <span style={{ color: themeConfig.status.error }}>*</span>
                </Col>
                <Col md="12">
                  <select
                    ref={rSelectedCountry}
                    onChange={(e) => handleCountrySelected(e.target.value)}
                  >
                    <option value={0}>--- Select an option ---</option>
                    {loadCountries()}
                  </select>
                </Col>
              </Row>
            )}
          </SectionWrapper>
          <SectionWrapper>
            {loadingCities && <PointersLine color={themeConfig.text.primary} />}
            {!loadingCities && (
              <Row>
                <Col md="12">
                  <label>City</label>&nbsp;
                  <span style={{ color: themeConfig.status.error }}>*</span>
                </Col>
                <Col md="12">
                  <select ref={rSelectedCity}>
                    <option value={0}>--- Select an option ---</option>
                    {loadCities()}
                  </select>
                </Col>
              </Row>
            )}
          </SectionWrapper>
          {(loadingUpdateSite || loadingCreateLocation) && (
            <SectionWrapper>
              <PointersLine color={themeConfig.text.primary} />
            </SectionWrapper>
          )}
          {editRowData && !loadingUpdateSite && (
            <SectionWrapper>
              <button onClick={() => handleUpdateSite()}>Update</button>
            </SectionWrapper>
          )}
          {!editRowData && !loadingCreateLocation && (
            <SectionWrapper>
              <button onClick={() => handleSaveSite()}>Create</button>
            </SectionWrapper>
          )}
        </FormCard>
      </GeneralStyle>
    </>
  );
};

export default SitesCreationForm;

SitesCreationForm.propTypes = {
  user: PropTypes.string,
  setFormTrigger: PropTypes.func,
  editRowData: PropTypes.object,
  setReloadRender: PropTypes.func,
};
